import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { CreateScoringCriteriaGQL } from "../../generated/graphql/scoringCriteria/create-scoringCriteria.graphql";
import { DeleteScoringCriteriaGQL } from "../../generated/graphql/scoringCriteria/delete-scoringCriteria.graphql";
import { UpdateScoringCriteriaGQL } from "../../generated/graphql/scoringCriteria/update-scoringCriteria.graphql";
import { GetScoringCriteriaGQL } from "../../generated/graphql/scoringCriteria/get-scoringCriteria.graphql";
import { CreateScoringCriteriaMutation, CreateScoringCriteriaMutationVariables } from "../../generated/graphql/scoringCriteria/create-scoringCriteria.graphql";
import { UpdateScoringCriteriaMutation, UpdateScoringCriteriaMutationVariables } from "../../generated/graphql/scoringCriteria/update-scoringCriteria.graphql";
import { GetScoringCriteriaQuery } from "../../generated/graphql/scoringCriteria/get-scoringCriteria.graphql";

export interface DeleteScoringCriteriaDto {
  id: number;
}

@Injectable({
  providedIn: "root",
})
export class FinancialService {
  constructor(
    private createScoringCriteriaGQL: CreateScoringCriteriaGQL,
    private deleteScoringCriteriaGQL: DeleteScoringCriteriaGQL,
    private updateScoringCriteriaGQL: UpdateScoringCriteriaGQL,
    private getScoringCriteriaGQL: GetScoringCriteriaGQL
  ) { }


  createScoringCriteria(
    variables: CreateScoringCriteriaMutationVariables
  ): Observable<CreateScoringCriteriaMutation> {
    return this.createScoringCriteriaGQL.mutate(variables).pipe(
      map((result) => result.data),
      catchError((error) => throwError(() => new Error("Failed to create scoring criteria: " + error)))
    );
  }


  deleteScoringCriteria(id: number): Observable<boolean> {
    return this.deleteScoringCriteriaGQL.mutate({
      id: { id } 
    }).pipe(
      map((result) => result.data.deleteScoringCriteria),
      catchError((error) =>
        throwError(() => new Error("Falha ao excluir critério: " + error))
      )
    );
  }


  updateScoringCriteria(
    variables: UpdateScoringCriteriaMutationVariables
  ): Observable<UpdateScoringCriteriaMutation> {
    return this.updateScoringCriteriaGQL.mutate({
      id: variables.id,
      data: variables.data,
    }).pipe(
      map((result) => result.data),
      catchError((error) => throwError(() => new Error("Failed to update scoring criteria: " + error)))
    );
  }


  getScoringCriteria(): Observable<GetScoringCriteriaQuery> {
    return this.getScoringCriteriaGQL.watch().valueChanges.pipe(
      map((result) => result.data),
      catchError((error) => throwError(() => new Error("Failed to fetch scoring criteria: " + error)))
    );
  }
}
